import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { createAction } from 'redux-actions';
import { actionTypePrefix, SimpleXHREndpoint, SimpleXHRMethod } from './constants';
export const makeGiveLlamaXHRCall = ({ username , onBadgeSent , onBadgeError  })=>{
    const data = {
        foruser: username
    };
    return makeXHRCall({
        endpoint: SimpleXHREndpoint.GIVE_LLAMA,
        method: SimpleXHRMethod.POST,
        data,
        onSuccess: onBadgeSent,
        onError: onBadgeError
    });
};
export const makeGivePointsXHRCall = (_param)=>{
    var { username , pointsAmount , message  } = _param, callbacks = _object_without_properties(_param, [
        "username",
        "pointsAmount",
        "message"
    ]);
    const data = {
        recipient_username: username,
        amount: pointsAmount,
        message: message || undefined
    };
    return makeXHRCall(_object_spread({
        endpoint: SimpleXHREndpoint.GIVE_POINTS,
        method: SimpleXHRMethod.POST,
        data
    }, callbacks));
};
export const makeInitGivePointsPopupXHRCall = ()=>{
    return makeXHRCall({
        endpoint: SimpleXHREndpoint.GIVE_POINTS_POPUP,
        method: SimpleXHRMethod.GET
    });
};
export const makeXHRCall = createAction(`${actionTypePrefix}/MAKE_XHR_CALL`, (payload)=>payload);
export const setIsLoading = createAction(`${actionTypePrefix}/SET_IS_LOADING`, (payload)=>payload);
export const storeResult = createAction(`${actionTypePrefix}/STORE_RESULT`, (payload)=>payload);
